import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const Protected = ({ Component, adminOnly }) => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Protected Component Mounted");

    const storedUser = secureLocalStorage.getItem("loginCredentials");
    console.log("Stored Login Data:", storedUser);

    if (!storedUser) {
      console.log("No login credentials found! Redirecting to login...");
      navigate("/login");
      return;
    }

    let userData;
    try {
      userData = typeof storedUser === "string" ? JSON.parse(storedUser) : storedUser;
      console.log("Parsed User Data:", userData);
    } catch (error) {
      console.error("Error parsing loginCredentials:", error);
      navigate("/login");
      return;
    }

    if (adminOnly) {
      if (!userData.user || userData.user.role !== "Admin") {
        console.log("User is not an admin! Redirecting to /dashboard");
        navigate("/dashboard");
      }
    }
  }, [navigate, adminOnly]);

  return (
    <div>
      <Component />
    </div>
  );
};

export default Protected;
